import bugsnag from '@/bugsnag'
let timeout
let errorCount = 0

function timedFunction (func, time) {
    return () => {
        console.log('TIMER RUNNING FUNCTION')
        try {
            func()
            errorCount = 0
        } catch (error) {
            bugsnag.notify(JSON.stringify(error))
            errorCount += 1
        }
        if (errorCount < 10) {
            timeout = setTimeout(timedFunction(func, time), time)
        } else {
            stopTimedFunction()
        }
    }
}

function startTimedFunction (func, time) {
    console.log('TIMER STARTING')
    if (timeout === null || timeout === undefined) {
        try {
            func()
            errorCount = 0
        } catch (error) {
            bugsnag.notify(JSON.stringify(error))
            errorCount += 1
        }
        if (errorCount < 10) {
            timeout = setTimeout(timedFunction(func, time), time)
            console.log('STARTED TIMER: ', timeout)
        } else {
            stopTimedFunction()
        }
    }
}

function stopTimedFunction () {
    console.log('STOPPING TIMER: ', timeout)
    clearTimeout(timeout)
    timeout = null
}

function hasTimedFunction () {
    return timeout !== null && timeout !== undefined
}

export default {
    startTimedFunction,
    stopTimedFunction,
    hasTimedFunction
}



// WEBPACK FOOTER //
// ./src/utils/timeout.js